import { useAuthStore } from '@/lib/stores/authStore'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import { useMenuItems } from '@/lib/hooks/useMenuItems'
import { forwardRef, Ref } from 'react'
import { useTranslation } from 'react-i18next'

const MyMenuDesktop = forwardRef((_, ref) => {
  const router = useRouter()
  const { user } = useAuthStore()
  const { t } = useTranslation('common')

  const handleLogout = () => {
    router.push('/login')
  }

  return (
    <div ref={ref as Ref<HTMLDivElement>} className="absolute right-0 top-0 pt-[50px]">
      <div
        className="flex w-[200px] flex-col gap-4 rounded-[28px] bg-white px-4 py-5"
        style={{
          boxShadow: '0 0 24px 0 rgba(38, 38, 38, 0.04)',
        }}
      >
        <div className="flex flex-col gap-1">
          <div className="text-sm font-semibold text-label-strong">
            {t('mymenuLine.user', { name: user?.name || '' })}
          </div>
          <div className="text-xs text-label-neutral">{user?.email}</div>
        </div>
        <div className="flex flex-col gap-2">
          {useMenuItems().map(item => {
            const { id, Icon, title, href } = item
            return (
              <Link href={href} key={`header-menu-desktop-${id}`}>
                <div className="flex h-11 flex-row items-center gap-3 rounded-2xl px-3 text-alternative hover:bg-alternative">
                  <Icon className="h-6 w-6 text-alternative" />
                  {title}
                </div>
              </Link>
            )
          })}
        </div>
        <div className="flex flex-row items-center justify-center">
          <button className="text-sm font-normal text-alternative underline" onClick={handleLogout}>
            {t('auth.logout')}
          </button>
        </div>
      </div>
    </div>
  )
})

MyMenuDesktop.displayName = 'MyMenuDesktop'
export default MyMenuDesktop
